import { Moment } from "moment";
import Utils from "../utils";
import { ApiResponseData } from "../../services/YourAppServer/YourAppServerApi.service";

// Requests
export abstract class SyncModel {
  public changes_since_ymd: number = Utils.MinYMD;
  public changes_since_hms: number = Utils.MinHMS;
  public get changes_since(): Moment {
    return Utils.GetMomentFromInt(this.changes_since_ymd, this.changes_since_hms);
  }
}

// Responses
/** Data mit mehreren models */
export abstract class SyncDataModel implements ApiResponseData {
  public request_at_ymd: number = Utils.MinYMD;
  public request_at_hms: number = Utils.MinHMS;
  public get request_at(): Moment {
    return Utils.GetMomentFromInt(this.request_at_ymd, this.request_at_hms);
  }
  public abstract get models(): DataModel[];
  public abstract DeserializeType(): void;

  /** hilfsfunktion um die modesl in die richtigen classen umzuwandeln
   * Achtung "get models()" darf kein erzeugtes array zurückgeben sondrn ein echtes (beispiel impressum, dabei geht es nicht) 
   */
  protected _DeserializeType(modelConstructor: new () => DataModel): void {
    const me = this;
    if (Array.isArray(me.models)) {
      const ModelPrototype = Object.getPrototypeOf(new modelConstructor());
      for (let i = 0; i < me.models.length; ++i) {
        const model = me.models[i];
        if (Object.getPrototypeOf(model) !== ModelPrototype) {
          const deserializedModel = Utils.GetExtend(new modelConstructor(), model);
          if (deserializedModel){
            deserializedModel.DeserializeSubTypes();
          }
          me.models[i] = deserializedModel;
        }
      }
    }
  }
}

/** SingleData mit nur einem model */
export abstract class SyncSingleDataModel<T extends DataModel> implements ApiResponseData {
  public request_at_ymd: number = Utils.MinYMD;
  public request_at_hms: number = Utils.MinHMS;
  public get request_at(): Moment {
    return Utils.GetMomentFromInt(this.request_at_ymd, this.request_at_hms);
  }
  public abstract get model(): T;
  /** setModel wird für _DeserializeType benötigt um den Typ zu setzen */
  protected abstract setModel(model: T);
  public abstract DeserializeType(): void;

  /** hilfsfunktion um die models in die richtigen classen umzuwandeln
   * Achtung setModel muss das Model auch speichern, es wird zum erzeugen der Klasse verwendet
   */
  protected _DeserializeType(modelConstructor: new () => T): void {
    const me = this;
    if (!Utils.IsNull(me.model)) {
        if (Object.getPrototypeOf(me.model) !== Object.getPrototypeOf(new modelConstructor())) {
          const deserializedModel = Utils.GetExtend(new modelConstructor(), me.model);
          if (deserializedModel){
            deserializedModel.DeserializeSubTypes();
          }
          me.setModel(deserializedModel);
      }
    }
  }
}

export abstract class DataModel {
  public DM_iPE: number = 1;
  public abstract get DM_Key(): number | string;
  public DeserializeSubTypes(): void { /* virtual, overwrite if need */ }
}
